import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
  },
  title: {
    fontSize: '22px',
    fontWeight: 500,
    color: theme.palette.common.black,
  },
  content: {
    minWidth: 310,
    padding: theme.spacing(3),
    marginBottom: 50,
    border: 'solid 1px #e5e8eb',
    boxShadow: '0.1px 1px 3px 0 rgba(16, 17, 21, 0.03)',
    borderRadius: 4,
    backgroundColor: '#ffffff',
  },
}));

const MainContentTemplate = ({ title, children }) => {
  const classes = useStyles();

  return (
    <div className={`mb-MainContentTemplate ${classes.root}`}>
      <div className={classes.title}>{title}</div>
      <div className={classes.content}>{children}</div>
    </div>
  );
};

export default MainContentTemplate;
